module.exports = __webpack_public_path__ + "static/media/mu.fcbb9709.svg";